import Navbar from "../../components/general/Navbar";
import BuyerSignupForm from "../../components/buyers/BuyerSignupForm";
import Footer from "../../components/general/Footer";

export default function BuyerSignupPage() {
  return (
    <>
      <Navbar />
      <BuyerSignupForm />
      <Footer />
    </>
  )
}

